import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { roleLabel } from "../utils/auth";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;

export default function ModifyUser() {
  const { state } = useLocation();
  const username = state?.username;
  const [user, setUser] = useState(null);
  const [loadError, setLoadError] = useState("");
  const [role, setRole] = useState("");
  const [rolePassword, setRolePassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState({ error: "", message: "" });
  useEffect(() => {
    let active = true;
    setUser(null);
    if (!username) return;
    axios.get(`${API_URL}/users/list-users`, { headers: { token: localStorage.getItem("token") } })
      .then(({ data }) => {
        if (!active) return;
        const account = data.userData.find(item => item.username === username);
        if (!account) { setLoadError("Användaren finns inte längre."); return; }
        setUser(account);
        setRole(String(account.role));
      })
      .catch(() => { if (active) setLoadError("Kunde inte hämta användaren. Gå tillbaka och försök igen."); });
    return () => { active = false; };
  }, [username]);

  async function submit(event, kind) {
    event.preventDefault();
    if (busy || !user) return;
    setResult({ error: "", message: "" });
    if (kind === "password" && newPassword !== confirmPassword) {
      setResult({ error: "Lösenorden matchar inte.", message: "" });
      return;
    }
    setBusy(true);
    try {
      const payload = kind === "role"
        ? { username: user.username, userRole: role, adminPassword: rolePassword }
        : { username: user.username, newPassword, adminPassword };
      const { data } = await axios.patch(`${API_URL}/users/admin-change-user${kind}`, payload,
        { headers: { token: localStorage.getItem("token") } });
      setResult({ message: data.message, error: "" });
      if (kind === "role") setUser(previous => ({ ...previous, role: Number(role) }));
    } catch (error) {
      setResult({ error: error.response?.data?.message || "Ändringen kunde inte sparas.", message: "" });
    } finally {
      setRolePassword(""); setAdminPassword(""); setNewPassword(""); setConfirmPassword(""); setBusy(false);
    }
  }

  return <main className="mx-auto w-full max-w-xl px-3 py-4"><div className="theme-card">
    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">Administration</p>
    <h1 className="mt-2 text-xl font-bold">Redigera användarroll</h1>
    {!username && <p className="mt-4">Välj en användare i användarhanteringen först.</p>}
    {loadError && <p role="alert" className="theme-alert-error mt-4">{loadError}</p>}
    {username && !user && !loadError && <p className="mt-4">Hämtar användare…</p>}
    {user && <>
      <div className="theme-panel my-4 break-words">
        <p className="font-semibold">{user.name || user.email}</p>
        <p className="break-all">{user.email}</p>
        <p className="mt-2">Nuvarande roll: {roleLabel(user.role)}</p>
      </div>
      {user.approvalStatus === "pending" && <p className="my-3">Kontot väntar på godkännande. En rolländring godkänner inte kontot. <Link className="underline" to="/account-approvals">Till kontogodkännande</Link></p>}
      <form onSubmit={event => submit(event, "role")} className="flex flex-col gap-4">
        <label>Ny roll<select className="theme-input mt-1 w-full" value={role} onChange={event => setRole(event.target.value)} required disabled={busy}>
          {[3,5,4,2,1].map(value => <option key={value} value={value}>{roleLabel(value)}</option>)}
        </select></label>
        <label>Bekräfta med ditt administratörslösenord<input className="theme-input mt-1 w-full" type="password" autoComplete="current-password" value={rolePassword} onChange={event => setRolePassword(event.target.value)} required disabled={busy}/></label>
        <button className="theme-button-primary" disabled={busy || Number(role) === user.role}>Spara roll</button>
      </form>
      {result.error && <p role="alert" className="theme-alert-error mt-4">{result.error}</p>}
      {result.message && <p role="status" className="theme-alert-success mt-4">{result.message}</p>}
      <details className="mt-8 border-t border-slate-300 pt-4">
        <summary className="cursor-pointer font-semibold">Återställ användarens lösenord</summary>
        <form onSubmit={event => submit(event, "password")} className="mt-4 flex flex-col gap-4">
          <label>Nytt lösenord<input className="theme-input mt-1 w-full" type="password" autoComplete="new-password" minLength={8} maxLength={72} value={newPassword} onChange={event => setNewPassword(event.target.value)} required disabled={busy}/></label>
          <label>Bekräfta nytt lösenord<input className="theme-input mt-1 w-full" type="password" autoComplete="new-password" value={confirmPassword} onChange={event => setConfirmPassword(event.target.value)} required disabled={busy}/></label>
          <label>Ditt administratörslösenord<input className="theme-input mt-1 w-full" type="password" autoComplete="current-password" value={adminPassword} onChange={event => setAdminPassword(event.target.value)} required disabled={busy}/></label>
          <button className="theme-button-primary" disabled={busy}>Spara lösenord</button>
        </form>
      </details>
    </>}
    <Link className="theme-button-secondary mt-6 inline-block" to="/user-management">Tillbaka till användarhanteringen</Link>
  </div></main>;
}
